// How the upload panel waits for the virus scan after the bytes are sent (uploads.tsx). It asks until
// the scan has answered: it used to stop after five minutes and show "Checking for viruses" for good,
// though the file was long clean.

/** How long a virus check usually takes at most; past it the panel says the check takes longer. */
export const SCAN_USUAL_MS = 5 * 60_000;

/** How long to wait before asking again: a second at first, then 2 s, then 15 s once past the usual time. */
export function scanPause(waitedMs: number, attempt: number): number {
  if (attempt < 10) return 1000;
  return waitedMs < SCAN_USUAL_MS ? 2000 : 15_000;
}
